export default {
    getAmbiences: { method: 'get', url: 'ambiences' },
    postAmbiences: { method: 'post', url: 'ambiences' },
    updateAmbiences: { method: 'put', url: 'ambiences/{id}' },
    deleteAmbiences: { method: 'delete', url: 'ambiences/{id}' },
}
